import { Subscription, SubscriptionStatus } from '@/shared/types/Billing';

const ACTIVE_SUBSCRIPTION_STATUSES = new Set([
  SubscriptionStatus.Active,
  SubscriptionStatus.Incomplete,
  SubscriptionStatus.IncompleteExpired,
  SubscriptionStatus.Trialing,
]);

export const isSubscriptionExpired = (subscriptionEndDate: Subscription['current_period_end']) => {
  return new Date() > new Date(subscriptionEndDate);
};

export const isSubscriptionActive = (subscription: Subscription) => {
  return (
    ACTIVE_SUBSCRIPTION_STATUSES.has(subscription.status) &&
    !isSubscriptionExpired(subscription.current_period_end) &&
    !subscription.payments_collection_paused
  );
};
